import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MarkdownConverter from '../MarkdownConverter.jsx';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import { loadAction } from '../../util/decorators';
import loadDataSources from '../../action/loadDataSources';

const $loadAction = args =>
  loadDataSources({ dataSourceConfigs: { content: 'content' }, ...args });

const mapStateToProps = state => ({
  body: _.get(state, 'dataSources.content[0].data.body'),
  title: _.get(state, 'dataSources.content[0].data.title'),
});

@connect(mapStateToProps)
@loadAction($loadAction)
export default class TextPageCookie extends React.PureComponent {
  static propTypes = {
    data: React.PropTypes.shape({
      title: React.PropTypes.string,
      body: React.PropTypes.string,
    }),
  };

  render() {
    const { title, body } = this.props;

    if (!body) {
      return null;
    }

    return (
      <PageWithSidebars removeAds>
      	<section className="text-page">
          <h1>{title}</h1>
          <MarkdownConverter markdown={body} />
        </section>
      </PageWithSidebars>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/TextPages/TextPageCookie.jsx